import React, { FC } from "react";
import { Icon, Heading, Checkbox, IconName, Text } from "@telia/teddy";
import "./ServiceCard.less";

interface Props {
    icon?: IconName;
    heading: string;
    description?: string;
    price: string;
    strikethrough?: string;
    onAdd: (checked: boolean | "indeterminate") => void;
    checked: boolean;
}

const ServiceCard: FC<Props> = ({ icon, heading, description, price, strikethrough, onAdd, checked }) => {
    return (
        <div className="service-card">
            {icon && (
                <div className="service-card__icon">
                    <Icon name={icon} size="lg" />
                </div>
            )}
            <div className="service-card__icon-mobile">
                <div className="service-card__iconWrapper-mobile">
                    {icon && <Icon name={icon} size="lg" />}
                    <Heading as="h4" variant="subsection-100">
                        {heading}
                    </Heading>
                </div>
                <Text className="service-card__description-mobile" variant="additional-100">
                    {description}
                </Text>
            </div>

            <div className="service-card__content">
                <div className="service-card__headingContainer">
                    <Heading as="h4" variant="subsection-100">
                        {heading}
                    </Heading>
                    {description && (
                        <Text className="service-card__description" variant="additional-100">
                            {description}
                        </Text>
                    )}
                </div>
                <div className="service-card__priceContainer">
                    <Checkbox className="service-card__checkbox">
                        <Checkbox.Trigger checked={checked} onCheckedChange={onAdd}>
                            <Checkbox.Indicator />
                        </Checkbox.Trigger>
                        <span>Legg til</span>
                    </Checkbox>
                    <div>
                        {strikethrough && (
                            <span className="service-card__strikethrough">{`${strikethrough},-/md`}</span>
                        )}
                        <span>{`${price},-/md`}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceCard;
